import HeroSection from "./sections/HeroSection";
import Features from "./sections/Features";
import ProofStrip from "./sections/ProofStrip";
import FAQ from "./sections/FAQ";
import SecondaryPages from "./sections/SecondaryPages";

const Home = () => {
  return (
    <>
      <HeroSection />
      <Features />
      <ProofStrip />
      <FAQ />
      <SecondaryPages />
    </>
  );
};

export default Home;
